import { render, staticRenderFns } from "./Product-review.vue?vue&type=template&id=b37dc1a8&"
import script from "./Product-review.vue?vue&type=script&lang=js&"
export * from "./Product-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports